import { Card, CardContent, CardFooter, CompendiaLogo } from "frontend-components";
import { useState, type ReactNode } from "react";
import { SurveyLayoutContext, type SurveyStepType } from "./surveyLayoutContext";
import type { Question, Survey } from "@pulse/api/surveyApi";

export default function SurveyLayout({
    children,
    survey,
    questions,
    isLoading,
    isPreview = false,
}: {
    children: ReactNode;
    survey: Survey | undefined;
    questions: Question[] | undefined;
    isLoading: boolean;
    isPreview?: boolean;
}) {
    const [stepType, setStepType] = useState<SurveyStepType>("start");
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState<number>(0);

    const startSurvey = () => {
        setStepType("question");
        setCurrentQuestionIndex(0);
    };

    const handlePrevious = () => {
        if (currentQuestionIndex > 0) {
            setCurrentQuestionIndex((prev) => prev - 1);
        }
    };

    const handleNext = () => {
        if (questions && currentQuestionIndex + 1 < questions.length) {
            setCurrentQuestionIndex((prev) => prev + 1);
        }
    };

    return (
        <SurveyLayoutContext.Provider
            value={{
                stepType,
                setStepType,
                currentQuestionIndex,
                setCurrentQuestionIndex,
                isLoading,
                startSurvey,
                handlePrevious,
                handleNext,
                isPreview,
                survey,
                questions,
            }}
        >
            <Card className="max-w-xl w-full bg-white shadow flex flex-col overflow-clip">
                {/* If no title, add padding to content */}
                <CardContent
                    className={
                        stepType === "question"
                            ? "pt-6 min-h-0 flex flex-1 flex-col"
                            : "pt-6 min-h-0 overflow-y-auto"
                    }
                    data-survey-response-card-content
                >
                    {children}
                </CardContent>
                <CardFooter className="text-left border-t mx-6 pt-3 shrink-0">
                    <CompendiaLogo />
                </CardFooter>
            </Card>
        </SurveyLayoutContext.Provider>
    );
}
